// extracted by mini-css-extract-plugin
export var modal = "_gv-0";